import axios, { AxiosResponse } from 'axios';

export const store = {
  getCampaignProgress: (
    appId: string,
    storeId: number,
  ): Promise<AxiosResponse> =>
    axios.get(
      `marketing/GetUserStatusOnLoyaltyCampaign?appId=${appId}&storeIDs=${storeId}`,
    ),

  getCollectionDetail: (prId: string): Promise<AxiosResponse> =>
    axios.get(`/Restaurant/PickupRestaurantDetails/${prId}`),

  getCollectionSummaries: (payload): Promise<AxiosResponse> =>
    axios.get(
      '/Restaurant/PickupPhysicalRestaurantSummariesFromCoordinates',
      payload,
    ),

  getDeliveryDetail: (vrId: number, options): Promise<AxiosResponse> =>
    axios.get(`/Restaurant/DeliveryRestaurantDetails/${vrId}`, options),

  getDeliverySummaries: (payload): Promise<AxiosResponse> =>
    axios.get('/Restaurant/DeliveryRestaurantSummaries', payload),

  getLocationAreaData: (prid: number): Promise<AxiosResponse> =>
    axios.get(`/Restaurant/GetLocationAreasForStore?storeId=${prid}`),
};
